import { checkPaymentRequired } from 'src/common/licenseUtils';
import { RootState } from 'src/store/store';
import { ChargeableFlow } from 'src/types/configuration';

export const selectApplicationLoading = (state: RootState) =>
  state.apply?.applicationLoading;
export const selectApplicationError = (state: RootState) =>
  state.apply?.applicationError;
export const selectApplicationFinished = (state: RootState) =>
  state.apply?.applicationFinished;
export const selectPermitApplicationData = (state: RootState) =>
  state.apply?.applicationData;
export const selectPermitApplicationRegistrant = (state: RootState) =>
  state.apply?.applicationData?.registrant;
export const selectApplicationNumber = (state: RootState) =>
  state.apply?.applicationNumber;
export const selectApplicationIsPaymentRequired = (
  state: RootState
): boolean => {
  const configuration = state.config?.settings?.express?.registration
    ?.application as ChargeableFlow;
  const paymentFees = state.payment.paymentFees;
  if (!paymentFees) {
    return false;
  }
  const total = paymentFees.summary?.total;
  if (!total) {
    return false;
  }
  return checkPaymentRequired(configuration);
};
